<template>
  <div class="asd20-school-details">
    <asd20-viewport scrollable>
      <asd20-page-header v-bind="pageHeaderContent" />

      <main class="asd20-school-details__body">
        <section class="asd20-contact">
          <!-- <h2>Contact</h2> -->
          <div class="button-group ">
            <asd20-button
              :link="'tel:' + school.phone"
              :label="school.phone"
              icon="phone"
              size="lg"
            />
            <asd20-button
              :link="school.website"
              target="_blank"
              label="Website"
              icon="website"
              size="lg"
            />
            <asd20-button
              :link="
                `https://www.google.com/maps/search/?api=1&query=${
                  school.address.street1
                }&origin_place_id=${school.name}`
              "
              target="_blank"
              label="Directions"
              icon="directions"
              size="lg"
            />
          </div>
        </section>
        <section class="asd20-school-details__primary-content">
          <!-- <asd20-open-seats
            :seats="openSeats"
            class="asd20-school-details__open-seats"/> -->

          <div
            v-if="school.administrators[0].lastName"
            class="asd20-school-details__leadership primary-section"
          >
            <asd20-list
              headline="Leadership"
              condensed
              align-top
              icon="committee"
            />
            <!-- <h2 v-if="school.administrators[0].lastName">Leadership</h2> -->
            <h3>
              <b>
                {{ school.administrators[0].firstName }}
                {{ school.administrators[0].lastName }}
                <br />
                <small v-if="school.administrators[0].lastName"
                  >Principal/Administrator</small
                >
              </b>
            </h3>

            <asd20-list>
              <asd20-list-item
                v-if="school.administrators[0].email"
                :description="school.administrators[0].email"
                condensed
                align-top
                icon="email"
              />
              <asd20-list-item
                v-if="school.administrators[0].phone"
                :description="school.administrators[0].phone"
                condensed
                align-top
                icon="phone-alt"
              />
            </asd20-list>
          </div>

          <asd20-list
            v-if="school.yearFounded || school.enrollment"
            :items="school.numbersListItems"
            class="asd20-school-details__numbers primary-section"
            headline="By the Numbers"
            icon="info"
          >
            <asd20-list-item
              v-if="school.educationLevels"
              label="Offered at This School"
              :description="getGradeRange"
              condensed
              align-top
              icon=""
            />
            <asd20-list-item
              v-if="school.yearFounded"
              label="Year Founded"
              :description="school.yearFounded.toString()"
              condensed
              align-top
              icon=""
            />
            <asd20-list-item
              v-if="school.enrollment"
              label="Enrollment"
              :description="school.enrollment.toString()"
              condensed
              align-top
              icon=""
            />
          </asd20-list>

          <asd20-list
            v-if="school.feederOrganizations.length > 0"
            :items="
              school.feederOrganizations.map(l => ({
                label: l,
                condensed: true,
              }))
            "
            class="asd20-school-details__feeder-schools primary-section"
            headline="Feeder Schools"
            icon="school"
          />

          <asd20-list
            v-if="school.uniqueOfferings.length > 0"
            :items="
              school.uniqueOfferings
                .map(u => ({
                  label: u,
                  alignTop: true,
                  checked: true,
                  condensed: true,
                }))
                .sort((a, b) =>
                  a.label > b.label ? 1 : b.label > a.label ? -1 : 0
                )
            "
            class="asd20-school-details__unique-offerings primary-section"
            headline="Unique Offerings"
            icon="group"
          />

          <asd20-list
            v-if="school.awardsHonors.length > 0"
            :items="
              school.awardsHonors
                .map(a => ({
                  label: a,
                  alignTop: true,
                  checked: true,
                  condensed: true,
                }))
                .sort((a, b) =>
                  a.label > b.label ? 1 : b.label > a.label ? -1 : 0
                )
            "
            class="asd20-school-details__awards-honors primary-section"
            icon="award"
            headline="Awards &amp; Honors"
          />

          <asd20-list
            v-if="school.educationLevels.indexOf('Preschool') > -1"
            :items="[
              {
                alignTop: true,
                checked: true,
                condensed: true,
                description:
                  '<a href=https://www.asd20.org/preschool>Learn more and apply.</a>',
              },
            ]"
            class="asd20-school-details__unique-offerings primary-section"
            headline="Preschool Offered"
            icon="thumb"
          />

          <!-- <asd20-list
            v-if="school.awardsHonorsListItems.length > 0"
            :items="school.awardsHonorsListItems"
            class="asd20-school-details__awards-honors"
            icon="award"
            headline="Awards &amp; Honors"
          />

          <asd20-list
            v-if="school.uniqueOfferingsListItems.length > 0"
            :items="school.uniqueOfferingsListItems"
            class="asd20-school-details__unique-offerings"
            headline="Unique Offerings"
            icon="group"
          />

          <asd20-list
            v-if="school.educationLevels.indexOf('Preschool') > -1"
            :items="[{ checked: true, condensed: true, description: 'Preschool may be available for families living inside school boundaries. <a href=https://www.asd20.org/preschool>Learn more and apply.</a>' }]"
            class="asd20-school-details__unique-offerings"
            headline="Preschool Offered"
            icon="bell"
          /> -->
        </section>

        <section class="asd20-school-details__secondary-content">
          <asd20-list
            v-if="academicsListItems.length > 0"
            :items="academicsListItems"
            class="asd20-school-details__academics-offerings"
            headline="Academics Offerings"
            icon="library"
          />
          <div class="otherOfferings">
            <asd20-list
              v-if="artsListItems.length > 0"
              :items="artsListItems"
              class="asd20-school-details__arts-offerings"
              headline="Arts Offerings"
              icon="arts"
            />
            <asd20-list
              v-if="athleticsListItems.length > 0"
              :items="athleticsListItems"
              class="asd20-school-details__athletics-offerings"
              headline="Athletics Offerings"
              icon="athletics"
            />
          </div>
        </section>
      </main>
    </asd20-viewport>
  </div>
</template>

<script>
import definitions from '@/data/definitions'
import Asd20List from '@asd20/ui/src/components/organisms/Asd20List'
import Asd20ListItem from '@asd20/ui/src/components/molecules/Asd20ListItem'
import Asd20Card from '@asd20/ui/src/components/molecules/Asd20Card'
import Asd20Button from '@asd20/ui/src/components/atoms/Asd20Button'
import Asd20FactoidsGroup from '@asd20/ui/src/components/molecules/Asd20FactoidsGroup'
import Asd20PageHeader from '@asd20/ui/src/components/organisms/Asd20PageHeader'
import Asd20OpenSeats from '@/components/organisms/Asd20OpenSeats'
import Asd20Viewport from '@asd20/ui/src/components/atoms/Asd20Viewport'
import Asd20TagGroup from '@asd20/ui/src/components/organisms/Asd20TagGroup'

export default {
  name: 'Asd20SchoolDetails',

  components: {
    Asd20FactoidsGroup,
    Asd20Button,
    Asd20List,
    Asd20ListItem,
    Asd20PageHeader,
    Asd20OpenSeats,
    Asd20Viewport,
    Asd20TagGroup,
  },

  props: {
    school: { type: Object, default: null },
  },

  computed: {
    openSeats() {
      if (!this.school) return
      if (this.school.openSeats === null || undefined) {
        return 'no data'
      }
      return this.school.openSeats.map(g => JSON.parse(g))
    },

    pageHeaderContent() {
      if (!this.school) return
      return {
        heading: this.school.title.replace(
          /(Elementary|Elementary-Middle|Middle|Middle-High|High|Elementary-Middle-High) School/,
          '<small>$1 School</small>'
        ),
        lead: this.school.elevatorPitch,
        imageUrl: this.school.exteriorPhotoUrl,
        organization: this.school,
      }
    },
    academicsListItems() {
      return this.school.offerings
        .filter(s =>
          s.offering.categories
            .map(oc => oc.category.title)
            .includes('Academics')
        )
        .map(a => ({
          label: a.offering.title,
          description: a.offering.description,
          alignTop: true,
          actionable: false,
          condensed: true,
          checked: true,
        }))
        .sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0))
    },
    artsListItems() {
      return this.school.offerings
        .filter(s =>
          s.offering.categories.map(oc => oc.category.title).includes('Arts')
        )
        .map(a => ({
          label: a.offering.title,
          alignTop: true,
          actionable: false,
          condensed: true,
          checked: true,
        }))
        .sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0))
    },
    athleticsListItems() {
      return this.school.offerings
        .filter(s =>
          s.offering.categories
            .map(oc => oc.category.title)
            .includes('Athletics')
        )
        .map(a => ({
          label: a.offering.title,
          alignTop: true,
          actionable: false,
          condensed: true,
          checked: true,
        }))
        .sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0))
    },
    getGradeRange() {
      let levels = this.school.educationLevels
      let gradeRange = []

      // Check for Preschool
      if (levels.includes('Preschool')) {
        gradeRange.push('Preschool')
      }

      // Check for Kindergarten
      if (levels.includes('Kindergarten')) {
        gradeRange.push('Kindergarten')
      }

      // Check for Elementary thru High
      if (
        levels.includes('Elementary') &&
        levels.includes('Middle') &&
        levels.includes('High')
      ) {
        gradeRange.push('Grades 1 - 12')
      } else if (
        levels.includes('Elementary') &&
        levels.includes('Middle') &&
        !levels.includes('High')
      ) {
        gradeRange.push('Grades 1 - 8')
      } else if (
        levels.includes('Elementary') &&
        !levels.includes('Middle') &&
        !levels.includes('High')
      ) {
        gradeRange.push('Grades 1 - 5')
      } else if (
        !levels.includes('Elementary') &&
        levels.includes('Middle') &&
        levels.includes('High')
      ) {
        gradeRange.push('Grades 6 - 12')
      } else if (
        !levels.includes('Elementary') &&
        levels.includes('Middle') &&
        !levels.includes('High')
      ) {
        gradeRange.push('Grades 6 - 8')
      } else if (
        !levels.includes('Elementary') &&
        !levels.includes('Middle') &&
        levels.includes('High')
      ) {
        gradeRange.push('Grades 9 - 12')
      }

      // Generate the final grade range string
      if (gradeRange.length > 0) {
        return gradeRange.join(', ')
      } else {
        return 'Grade range not specified'
      }
    },
  },
}
</script>

<style lang="scss">
@import '@asd20/ui/src/design/_variables.scss';
@import '@asd20/ui/src/design/_mixins.scss';

.asd20-school-details {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;

  .asd20-icon {
    fill: var(--color__accent-t40);
  }

  .asd20-contact {
    padding: space(1);
  }
  .asd20-page-header__main {
    background: var(--color__secondary-s30);
  }
  .asd20-page-header__lead {
    color: var(--color__accent-t90);
  }
  .asd20-page-header__content {
    width: auto;
  }
  .asd20-page-header__image {
    max-width: 1000px;
  }
  .asd20-page-header__image img {
    object-position: center;
  }
  .asd20-page-header__image:after {
    background: initial;
  }
  .asd20-page-header__top img {
    border: 2px solid white;
  }
  .asd20-page-header__tools {
    flex-direction: row;
  }
  .asd20-page-header .back {
    order: 0;
  }
  .asd20-page-header .right {
    order: 2;
  }

  .button-group {
    // background: asd20-swatch('background-alt', 5);
    display: flex;
    flex-shrink: 0;
    justify-content: space-around;

    // & > :first-child {
    //   margin-right: auto;
    // }
  }

  .asd20-page-header h1 small {
    font-size: 1.25rem;
    color: var(--color__accent-t90);
    text-transform: uppercase;
    opacity: 1;
    position: relative;
    top: -2rem;

    &::before {
      content: '\a';
      white-space: pre;
    }
  }

  .asd20-page-header__top + h1 {
    // margin-top: space(2);
  }

  .asd20-page-header__top img {
    display: block;
    object-fit: cover;
    overflow: hidden;
    width: space(3);
    height: space(3);
    background: white;
    border-radius: 50%;
  }

  &__body {
    overflow-y: auto;
  }

  &__primary-content {
    background: asd20-swatch('background-alt', 7);
    background-image: url('/img/chalk-dark.png');
    background-position-y: top;
    padding: 0 space(1);
    display: flex;
    flex-wrap: wrap;
    .primary-section {
      width: 100%;
      padding: 0 0 3rem 0;
    }
    h2 {
      color: asd20-swatch('primary');
      font-size: 1.25rem;
    }
    h3 {
      font-size: 1rem;
    }
  }

  &__secondary-content {
    padding: space(1);
    display: flex;
    flex-direction: column;
    .asd20-school-details__academics-offerings {
      max-width: 90%;
      padding-bottom: 2rem;
    }
    .asd20-school-details__athletics-offerings {
      margin-top: 2rem;
    }
  }

  .asd20-list__headline {
    font-size: 1.25rem !important;
    color: asd20-swatch('primary');
  }

  .asd20-list__items {
    margin: 0;
  }

  .asd20-list-item--checked {
    &::before {
      margin-top: space(0.125);
    }
  }
}

@media (min-width: 768px) {
  .asd20-school-details {
    &__primary-content {
      padding: space(2);
      .primary-section {
        width: 49%;
      }
    }
    &__secondary-content {
      padding: space(2);
      display: flex;
      flex-direction: row;
      .asd20-school-details__academics-offerings {
        max-width: 60%;
        padding-right: 2rem;
      }
    }
  }
  .hide-on-desktop {
    display: none !important;
  }
}

@media (min-width: 1024px) {
  .asd20-school-details {
    &__primary-content {
      padding: space(2);
      .primary-section {
        width: 31%;
        padding: 0 1vw 3rem 1vw;
      }
    }
    .asd20-contact {
      padding: space(1) space(3);
    }
  }
}
</style>
